import React, { useCallback, useEffect, useRef, useState } from "react";
import ShowAllStyles from "./ShowAll.styles";
import customTableStyles from "../../../../global/components/CustomTable/customTable.styles";
import {
  Box,
  Button,
  Grid,
  Popover,
  Typography,
  Stack,
  Menu,
  MenuItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import MetaListStyles from "../../../MetaData/components/MetaList/MetaList.styles";
import YhTable, { YhTableColumn, YhTableCellParams } from "../../../../ui/YhTable";
import YhInput from "../../../../ui/YhInput";
import YhSelect from "../../../../ui/YhSelect";
import YhButton from "../../../../ui/YhButton";
import YhModal from "../../../../ui/YhModal";
import { YhDateRangePicker } from "../../../../ui/YhDateTimePicker";
import {
  EmailOutlined,
  LocalPhone,
  WhatsApp,
  LocationOnOutlined,
  CalendarTodayOutlined,
} from "@mui/icons-material";
import {
  isTruthy,
  openErrorNotification,
  openSuccessNotification,
} from "../../../../helpers/methods";

import CustomButton from "../../../../global/components/CustomButton/CustomButton";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/close.svg";

import {
  changeStatusApi,
  changeUserPassword,
  getAllUsers,
  getIVRUsers,
  setUserGrantsApi,
  updateUnmapUser,
} from "./ShowAllService";
import notifiers from "../../../../global/constants/NotificationConstants";
import {
  hasPrivilegeAction,
  isSuperAdminUser,
} from "../../../../Shared/AppDrawer/menuPrivileges";
import CustomLoader from "../../../../global/components/CustomLoader/CustomLoader";
import CustomDialog from "../../../../global/components/CustomModal/CustomModal";
import CustomRadioButton from "../../../../global/components/CustomRadioButton/CustomRadioButton";
import customErrorHandler from "../../../../utils/customErrorHandler";
import AddLoan from "../AddLoan/AddLoan";
import LoanList from "../AddLoan/RoleTabContent";

import { useSelector } from "react-redux";
import { selectActiveOrganizationId } from "../../../../redux/authSlice";
import { store } from "../../../../utils/store";
import history from "../../../../utils/history";
import urls from "../../../../global/constants/UrlConstants";
import { useHistory } from "react-router-dom";
import { ReactComponent as VerticalDotIcon } from "../../../../assets/icons/verticalDot.svg";

import { getTeamList } from "../../../MetaData/components/MetaList/components/AddTeamMetaList/CreateService";
import {
  OrgNameCell,
  useOrgNameMap,
} from "../../../../Shared/Organization/OrganizationSelect";
import LiveIvrCallsPanel from "./LiveIvrCallsPanel";

const SearchSvg = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" />
    <path d="M21 21l-4.35-4.35" />
</svg>
);

const getInitials = (name: string) => {
  if (!name) return "";
  const parts = name.trim().split(" ");
  if (parts.length > 1) return (parts[0][0] + parts[1][0]).toUpperCase();
  return name.slice(0, 2).toUpperCase();
};

const getRandomColorClass = (name: string) => {
  const colors = [
    "bg-indigo-50 text-indigo-700",
    "bg-emerald-50 text-emerald-700",
    "bg-amber-50 text-amber-700",
    "bg-sky-50 text-sky-700",
    "bg-rose-50 text-rose-700",
    "bg-violet-50 text-violet-700",
  ];
  if (!name) return colors[0];
  const charCode = name.charCodeAt(0) || 0;
  return colors[charCode % colors.length];
};

const ShowAll = () => {
  const classes = ShowAllStyles;
  const customTableClasses = customTableStyles;
  const privileges = store.getState().auth?.privileges || {};
  // Only admins (or holders of Roles & Privileges edit) may hand out export
  // access — mirrors requirePrivilege on PUT /leadExportAccess.
  const canGrantExport =
    isSuperAdminUser() ||
    hasPrivilegeAction(privileges, "Roles & Privileges", ["edit"]);
  const activeOrganizationId = useSelector(selectActiveOrganizationId);
  const orgNameMap = useOrgNameMap();
  const [search, setSearch] = useState<string>("");
  const [debouncedSearch, setDebouncedSearch] = useState<string>("");
  const ivrLoadedRef = useRef(false);
  const teamsLoadedForOrgRef = useRef<string | null>(null);
  const [userDataSource, setUserDataSource] = useState<any>([]);
  const [userDataSource1, setUserDataSource1] = useState<any>([]);
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [count, setCount] = useState<number>(5);
  const [getAddTeamMetaDataDylog, setGetAddTeamMetaDataDylog] =
    useState<boolean>(false);
  const navigate = useHistory();
  const [fixData, setFixData] = useState<any[]>([]);
  const [pageNumber, setPageNumber] = React.useState(0);
  const userPerPage = 10;
  const userCount = userDataSource.length;
  const pageVisited = pageNumber * userPerPage;
  const displayRows = userDataSource.slice(
    pageVisited,
    pageVisited + userPerPage
  );
  const [userId, setUserId] = useState("");
  const [status, setStatus] = useState("");
  const [apiResponse, setApiResponse] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState({ id: "", status: 0 });
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isDialogOpenLoan, setIsDialogOpenLoan] = useState<any>(false);
  const [isDialogOpenLoanList, setIsDialogOpenLoanList] = useState<any>(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [userRow_Id, setUserRow_Id] = useState<string>();
  const [rowStatus, setRowStatus] = useState();
  const [popOverRow, setPopOverRow] = useState<any>(null);
  const [accessRow, setAccessRow] = useState<any>(null);
  const [accessGrants, setAccessGrants] = useState({
    leadExport: false,
    paymentsView: false,
    paymentsSend: false,
  });
  const [savingGrants, setSavingGrants] = useState(false);
  const [filterModel, setFilterModel] = useState({});
  const [teamdata, setTeamData] = useState([]);
  const [passwordReset, setPasswordReset] = useState<any>(false);
  const [passwordResetId, setPasswordResetId] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [selectedDateRange, setSelectedDateRange] = useState<{
    from: string | null;
    to: string | null;
  }>({ from: null, to: null });
  const [openView, setOpenView] = React.useState(false);
  const [metaData, setMetaData] = useState<any>({});
  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: 25,
    page: 0,
  });
  const [offialDetailState, setOffialDetailState] = useState<any>({});
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [menuPosition, setMenuPosition] = useState<{ top: number; left: number } | null>(null);
  const [selectedRow, setSelectedRow] = useState<null | any>(null);
  const [userData, setUserData] = useState<any>([]);
  const isFirstDateRangeEffect = React.useRef(true);

  useEffect(() => {
    const t = window.setTimeout(() => setDebouncedSearch(search.trim()), 400);
    return () => window.clearTimeout(t);
  }, [search]);

  const loadTeamOptions = useCallback(async () => {
    try {
      const response3 = await getTeamList();
      const data3 = (response3?.data || []).flatMap((team: any) => {
        const entries: any[] = [];
        if (team.team_name) {
          entries.push({
            id: team._id,
            label: team.team_name,
            isParent: true,
          });
        }
        if (Array.isArray(team.sub_teams)) {
          team.sub_teams.forEach((subTeam: any) => {
            entries.push({
              id: subTeam._id,
              label: subTeam.team_name,
              isParent: false,
            });
          });
        }
        return entries;
      });
      setTeamData(data3);
    } catch (error: any) {
      console.warn("Team list:", error?.message || error);
    }
  }, []);

  const loadIvrUsersOnce = useCallback(async () => {
    if (ivrLoadedRef.current) return;
    ivrLoadedRef.current = true;
    try {
      const userDataRes = await getIVRUsers();
      setUserData(
        (userDataRes.data || userDataRes.users || [])?.map((i: any) => {
          const uuid = String(i.uuid || i.user_id || "");
          return {
            id: String(i.user_id || uuid),
            label: i.name || uuid,
            uuid,
          };
        })
      );
    } catch (ivrErr: any) {
      setUserData([]);
      console.warn("IVR users:", ivrErr?.message || ivrErr);
    }
  }, []);

  const tableDataShowHandler = useCallback(async () => {
    try {
      setApiResponse(true);
      setLoading(true);

      const orgKey = String(activeOrganizationId || "all");
      const teamPromise =
        teamsLoadedForOrgRef.current === orgKey
          ? Promise.resolve()
          : loadTeamOptions().then(() => {
              teamsLoadedForOrgRef.current = orgKey;
            });

      const payload = {
        startDate: selectedDateRange?.from ? selectedDateRange?.from : "",
        endDate: selectedDateRange?.to ? selectedDateRange?.to : "",
        pageNumber: paginationModel.page,
        pageSize: paginationModel.pageSize,
        userId: store.getState().auth.userId,
        team_id: offialDetailState?.team_id?.id
          ? offialDetailState?.team_id?.id
          : "",
        search: debouncedSearch || "",
      };

      const [response] = await Promise.all([
        getAllUsers(payload),
        teamPromise,
        loadIvrUsersOnce(),
      ]);

      setMetaData(response.metadata || { total: 0, page: 0 });
      if (!response?.data?.length) {
        setUserDataSource1([]);
        setUserDataSource([]);
      }

      const source1 = (response.data || []).filter((row: any) => {
        if (!row?.isSuperAdmin) return true;
        const roles = row?.memberships || [];
        const hasTenantRole = roles.some(
          (m: any) => m?.roleSlug && m.roleSlug !== "super_admin"
        );
        return hasTenantRole;
      });

      setUserDataSource1(source1);
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    } finally {
      setApiResponse(false);
      setLoading(false);
    }
  }, [
    activeOrganizationId,
    selectedDateRange?.from,
    selectedDateRange?.to,
    paginationModel.page,
    paginationModel.pageSize,
    offialDetailState?.team_id?.id,
    debouncedSearch,
    loadTeamOptions,
    loadIvrUsersOnce,
  ]);

  useEffect(() => {
    setUserDataSource1([]);
    setUserDataSource([]);
    setMetaData({ total: 0, page: 0 });
    teamsLoadedForOrgRef.current = null;
    setPaginationModel((prev) =>
      prev.page === 0 ? prev : { ...prev, page: 0 }
    );
  }, [activeOrganizationId]);

  useEffect(() => {
    if (isFirstDateRangeEffect.current) {
      isFirstDateRangeEffect.current = false;
      return;
    }
    setPaginationModel((prev) =>
      prev.page === 0 ? prev : { ...prev, page: 0 }
    );
  }, [selectedDateRange]);

  useEffect(() => {
    tableDataShowHandler();
  }, [tableDataShowHandler]);

  useEffect(() => {
    setPaginationModel((prev) =>
      prev.page === 0 ? prev : { ...prev, page: 0 }
    );
  }, [debouncedSearch, offialDetailState?.team_id?.id]);
  interface typeOfTeamdataItem {
    team_name: any; // Specify the type explicitly as a number
    _id: any;
  }
  const handleChange = (value: any) => {
    setPaginationModel({
      ...paginationModel,
      pageSize: value.target.value,
      page: 0,
    });
  };
  const onClickHandler = () => {
    setUserId("");
    navigate.push(urls.addTeamViewPath);
  };

  const handleEdit = (id: string) => {
    setUserId(id);
    navigate.push(urls.editTeamViewPath.replace(":id", id));
  };
  const handleAutocompleteChange = async (name: string, value: any) => {
    if (!value || value.label === "All") {
      setOffialDetailState((prevFormData: any) => ({
        ...prevFormData,
        [name]: {
          error: "",
          value: value?.label || "",
          id: null,
        },
      }));
      return;
    }

    setOffialDetailState((prevFormData: any) => ({
      ...prevFormData,
      [name]: {
        error: "",
        value: value.label,
        id: value.id,
      },
    }));
  };

  const handleTeamChange = (teamId: string) => {
    if (!teamId) {
      handleAutocompleteChange("team_id", null);
      return;
    }
    const opt = (teamdata as any[]).find(
      (t: any) => String(t.id) === String(teamId)
    );
    handleAutocompleteChange("team_id", opt || null);
  };

  const teamOptions = (teamdata || []).map((t: any) => ({
    label: t.isParent ? t.label : `  ${t.label}`,
    value: String(t.id),
  }));

  const saveIvrMapping = async (
    row: any,
    uuid: string,
    action: "map" | "unmap" | "remove" = uuid ? "map" : "remove"
  ) => {
    try {
      const response = await updateUnmapUser({
        id: row._id,
        uuid: uuid || "",
        action,
      });
      if (response?.success === 1) {
        openSuccessNotification(
          response?.message ||
            (action === "map"
              ? "IVR mapped"
              : action === "unmap"
                ? "IVR unmapped"
                : "IVR removed")
        );
        tableDataShowHandler();
        return;
      }
      openErrorNotification(response?.message || notifiers.GENERIC_ERROR);
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error?.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };
  const handleLoan = (id: string, statusVal: any) => {
    setIsDialogOpenLoan(true);
    setUserId(id);
    setStatus(statusVal);
    setAnchorEl(null);
  };

  const handleCloseLoan = () => {
    setIsDialogOpenLoan(false);
    tableDataShowHandler();
  };

  const handleLoanList = (id: string, statusVal: any) => {
    setIsDialogOpenLoan(false);
    setAnchorEl(null);
    setUserId(id);

    setIsDialogOpenLoanList(true);
    setStatus(statusVal);
  };

  const handleCloseLoanList = () => {
    setIsDialogOpenLoanList(false);
    tableDataShowHandler();
  };

  const changeStatus = async (status: any, id: any) => {
    try {
      const row = (userDataSource1 || []).find(
        (u: any) => String(u.user_id || u._id) === String(id)
      );
      if (row?.isSuperAdmin) {
        openErrorNotification("Super admin cannot be deactivated");
        return;
      }
      const response = await changeStatusApi(status, id);

      customErrorHandler(response);
      openSuccessNotification(response.message);
      setIsDialogOpen(false);
      tableDataShowHandler();
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  const handleViewSalary = (user_id: string) => {
    history.push({
      pathname: urls.salarySlipViewPath,
      state: { fromPage: user_id }, //"64807274ee4348490a2181e1"
    });
  };
  const handleSetPassword = (user_id: string) => {
    setAnchorEl(null);
    setPassword("");
    setPasswordConfirm("");
    setPasswordResetId(user_id);
    setPasswordReset(true);
  };
  const handleSetPasswordClose = () => {
    setPasswordReset(false);
    setPassword("");
    setPasswordConfirm("");
    setPasswordResetId("");
  };
  const handlePopOver = (
    event: React.MouseEvent<HTMLButtonElement>,
    user_id: string,
    status: any,
    row?: any
  ) => {
    setAnchorEl(event.currentTarget);
    setUserRow_Id(user_id);
    setRowStatus(status);
    setPopOverRow(row || null);
  };

  /** True when the member's per-user override already includes these actions. */
  const rowHasGrant = (row: any, moduleKey: string, actions: string[]) => {
    const granted = row?.privilegeOverrides?.[moduleKey];
    if (!Array.isArray(granted)) return false;
    const normalized = granted.map((a: any) =>
      String(a || "").trim().toLowerCase()
    );
    if (normalized.includes("full control")) return true;
    return actions.some((a) => normalized.includes(a));
  };

  const readGrantsFromRow = (row: any) => ({
    leadExport: rowHasGrant(row, "All Lead", ["export", "download"]),
    paymentsView: rowHasGrant(row, "Payment", ["view"]),
    paymentsSend: rowHasGrant(row, "Payment", ["edit"]),
  });

  const openAccessDialog = (row: any) => {
    setAccessRow(row);
    setAccessGrants(readGrantsFromRow(row));
    handleClose();
  };

  const closeAccessDialog = () => {
    setAccessRow(null);
  };

  const handleSaveGrants = async () => {
    if (!accessRow) return;
    try {
      setSavingGrants(true);
      const response = await setUserGrantsApi(accessRow._id, accessGrants);
      if (response?.success) {
        openSuccessNotification(response.message || "Access updated");
        closeAccessDialog();
        tableDataShowHandler();
      } else {
        openErrorNotification(response?.message || notifiers.GENERIC_ERROR);
      }
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error?.message) ? error.message : notifiers.GENERIC_ERROR
      );
    } finally {
      setSavingGrants(false);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  // const getTeamName = (id: any) => {
  //   console.log(id,"id::::::::::::::::")
  //   const val: any = teamdata.filter(
  //     (item: any) => item._id === id
  //   );
  //   const ans = val?.length > 0 ? val[0]?.team_name : "";
  //   console.log(ans,"kshfkafhakffjksfs")
  //   return <Typography sx={classes.rowtext}>{ans}</Typography>;
  // };
  const getTeamName = (id: any) => {
    console.log(id, "id::::::::::::::::");
    const val: any = teamdata.filter((item: any) => item.id === id);
    const ans = val?.length > 0 ? val[0]?.label : "";
    console.log(ans, "Resolved Team Name");
    return ans; // Return the plain string
  };

  const renderMenu = () => (
    <Menu
        open={Boolean(menuPosition)}
        onClose={() => {
            setMenuPosition(null);
            setSelectedRow(null);
        }}
        anchorReference="anchorPosition"
        anchorPosition={menuPosition ? { top: menuPosition.top, left: menuPosition.left - 190 } : undefined}
        PaperProps={{ sx: { width: 220, maxWidth: '100%' } }}
        sx={MetaListStyles.menuItem}
    >
        <MenuItem style={{ cursor: "default" }}>
            <ListItemText>Actions</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => {
            if (selectedRow?._id) {
              handleEdit(selectedRow._id);
            }
            setMenuPosition(null);
        }
        }>
            <ListItemIcon>
                <EditIcon fontSize="small" />
            </ListItemIcon>

            <ListItemText>Edit</ListItemText>

        </MenuItem>
        {/* <MenuItem onClick={() => {
          
        }}>
            <ListItemIcon>
                <DeleteOutlineIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Delete</ListItemText>
        </MenuItem> */}
    </Menu>
);
  // const getTeamName = (id: any) => {
  //   console.log(id, "id::::::::::::::::");
  // console.log(teamdata,"teamsssssssssssss")
  //   // Use flatMap to combine main teams and sub-teams into one array and find the team name
  //   const team = teamdata.flatMap((item: any) => [
  //     ...item.sub_teams?.filter((sub: any) => sub._id === id) || [],
  //     item._id === id ? item : []
  //   ]).find((item: any) => item.team_name);
  
  //   const teamName = team ? team.team_name : "";
  //   console.log(team, "Resolved Team Name");
  //   return teamName;
  // };
  
  
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const columns: YhTableColumn[] = [
    {
      headerName: "User Details",
      field: "name",
      minWidth: 260,
      flex: 1,
      renderCell: (params: YhTableCellParams) => {
        const name = params.row?.name || "Unknown";
        const initials = getInitials(name);
        const colorClass = getRandomColorClass(name);
        return (
          <div className="flex items-center gap-3 py-2">
            <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-sm font-bold ${colorClass}`}>
              {initials}
            </div>
            <div className="flex flex-col">
              <span className="text-sm font-semibold text-[#111827]">
                {name}
              </span>
              {params.row?.employee_id ? (
                <span className="mt-1 w-max rounded bg-emerald-50 px-1.5 py-0.5 text-[11px] font-medium text-emerald-700 ring-1 ring-inset ring-emerald-600/20">
                  {params.row?.employee_id}
                </span>
              ) : null}
            </div>
          </div>
        );
      },
    },
    {
      headerName: "Team Name",
      field: "teamName",
      minWidth: 120,
      renderCell: (params: YhTableCellParams) => {
        const parseTeamId = (teamId: string | undefined) => {
          try {
            return teamId ? JSON.parse(teamId) : [];
          } catch (error) {
            return [];
          }
        };
        const teamNames = params.row?.userOffices[0]
          ? parseTeamId(params.row.userOffices[0]?.team_id).map(getTeamName)
          : parseTeamId(params.row.userOffices?.team_id).map(getTeamName);
        
        const teamText = teamNames.join(', ');
        return (
          <span className="text-[13px] font-medium text-[#374151]">
            {teamText || "—"}
          </span>
        );
      },
    },
    {
      headerName: "Role",
      field: "teamRoleName",
      minWidth: 120,
      renderCell: (params: YhTableCellParams) => {
        const role = params.row?.userOffices[0]?.teamRoleName || params.row?.userOffices?.teamRoleName;
        return (
          <span className="text-[13px] font-medium text-[#374151]">
            {role || "—"}
          </span>
        );
      },
    },
    {
      headerName: "Organization",
      field: "organizationId",
      minWidth: 150,
      flex: 1,
      renderCell: (params: YhTableCellParams) => {
        const row = params.row || {};
        const oid =
          row.organizationId ||
          row.memberships?.[0]?.organizationId ||
          row.userOffices?.[0]?.organizationId ||
          row.userOffices?.organizationId ||
          null;
        return (
          <OrgNameCell
            organizationId={oid}
            map={orgNameMap}
            fallbackLabel={
              row.organizationName ||
              row.memberships?.[0]?.organizationName ||
              row.organization?.name ||
              row.organization?.brandName
            }
          />
        );
      },
    },

    {
      headerName: "Contact Info",
      field: "email",
      minWidth: 220,
      flex: 1,
      renderCell: (params: YhTableCellParams) => (
        <div className="flex flex-col justify-center gap-1.5 py-2">
          {params.row.email && (
            <div className="flex items-center gap-2 text-[13px] font-medium text-[#4B5563]">
              <EmailOutlined sx={{ fontSize: 16 }} />
              <span className="truncate">{params.row.email}</span>
            </div>
          )}
          {params.row.phone && (
            <div className="flex items-center gap-2 text-[13px] font-medium text-[#4B5563]">
              <LocalPhone sx={{ fontSize: 16 }} />
              <span>{params.row.phone}</span>
            </div>
          )}
          {params.row.whatsapp && (
            <div className="flex items-center gap-2 text-[13px] font-medium text-[#4B5563]">
              <WhatsApp sx={{ fontSize: 16 }} />
              <span>{params.row.whatsapp}</span>
            </div>
          )}
        </div>
      ),
    },
    {
      headerName: "Location",
      field: "location",
      minWidth: 180,
      flex: 1,
      renderCell: (params: YhTableCellParams) => {
        const city = params.row.city || "";
        const state = params.row.states?.[0]?.state_name || "";
        const country = params.row.countries?.[0]?.country_name || "";
        return (
          <div className="flex items-start gap-2 py-2 text-[13px] font-medium text-[#4B5563]">
            <LocationOnOutlined sx={{ fontSize: 18, marginTop: "2px" }} className="shrink-0" />
            <div className="flex flex-col gap-0.5">
              <span>{city}{city && state ? ", " : ""}{state}</span>
              <span className="text-[#6B7280]">{country}</span>
            </div>
          </div>
        );
      },
    },
    {
      headerName: "Dates",
      field: "dob",
      minWidth: 160,
      flex: 1,
      renderCell: (params: YhTableCellParams) => {
        const dob = params.row?.dob;
        const doj = params.row?.userOffices[0]?.joining;
        return (
          <div className="flex flex-col justify-center gap-1.5 py-2">
            {dob && (
              <div className="flex items-center gap-2 text-[13px] font-medium text-[#4B5563]">
                <CalendarTodayOutlined sx={{ fontSize: 16 }} />
                <span>DOB: {dob}</span>
              </div>
            )}
            {doj && (
              <div className="flex items-center gap-2 text-[13px] font-medium text-[#4B5563]">
                <CalendarTodayOutlined sx={{ fontSize: 16 }} />
                <span>DOJ: {doj}</span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      headerName: "Leaves",
      field: "LeaveBalance",
      minWidth: 130,
      flex: 1,
      renderCell: (params: YhTableCellParams) => {
        const total = params.row?.leaves?.[0]?.total_leave_available ?? "—";
        const sick = params.row?.leaves?.[0]?.sick_leave_available ?? "—";
        const casual = params.row?.leaves?.[0]?.casual_leave_available ?? "—";
        return (
          <div className="flex flex-col justify-center gap-1 text-[13px] font-medium text-[#4B5563]">
            <span>Total: {total}</span>
            <span>Sick: {sick}</span>
            <span>Casual: {casual}</span>
          </div>
        );
      },
    },
    {
      headerName: "Status",
      field: "status",
      minWidth: 110,
      renderCell: (params: YhTableCellParams) => {
        const isActive = params.row.status == 1;
        const isSuper = !!params.row?.isSuperAdmin;
        
        if (!privileges || (!privileges?.["Team List"]?.includes("delete") && !privileges?.["Team List"]?.includes("full control"))) {
          return null;
        }

        if (isSuper) {
          return (
            <span className="inline-flex items-center gap-1.5 rounded-full bg-[#F9F0F4] px-3 py-1 text-[13px] font-medium text-[#841C39]">
              Super Admin
            </span>
          );
        }

        return (
          <button
            onClick={() => changeStatus(params.row.status, params.row.user_id)}
            className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[13px] font-medium transition ${
              isActive 
                ? "bg-emerald-50 text-emerald-700 hover:bg-emerald-100" 
                : "bg-rose-50 text-rose-700 hover:bg-rose-100"
            }`}
          >
            <span className={`h-1.5 w-1.5 rounded-full ${isActive ? "bg-emerald-500" : "bg-rose-500"}`}></span>
            {isActive ? "Active" : "Deactive"}
          </button>
        );
      },
    },
    {
      headerName: "IVR Mapping",
      field: "uuid",
      minWidth: 240,
      flex: 1,
      renderCell: (params: YhTableCellParams) => {
        if (params.row?.isSuperAdmin) {
          return <span className="text-[13px] text-[#9CA3AF]">—</span>;
        }
        const stored = String(params.row.uuid || "");
        const hit = (userData || []).find(
          (u: any) => String(u.uuid) === stored || String(u.id) === stored
        );
        const stale = Boolean(stored) && !hit;
        return (
          <div className="flex w-full items-center gap-1.5 py-1">
            <YhSelect
              clearable
              placeholder="Map IVR"
              searchPlaceholder="Search agent..."
              showOptionIcon={false}
              className="!h-9 min-w-0 flex-1 text-[13px]"
              value={hit ? String(hit.uuid) : ""}
              options={(userData || []).map((u: any) => ({
                label: u.label,
                value: String(u.uuid),
              }))}
              onChange={(e) => {
                const uuid = String(e.target.value || "");
                if (!uuid) {
                  saveIvrMapping(params.row, "", "unmap");
                  return;
                }
                const selected = (userData || []).find(
                  (item: any) => String(item.uuid) === uuid
                );
                if (selected) {
                  saveIvrMapping(params.row, String(selected.uuid), "map");
                }
              }}
            />
            {hit ? (
              <button
                type="button"
                onClick={() => saveIvrMapping(params.row, "", "unmap")}
                className="shrink-0 rounded-lg border border-[#E5E7EB] bg-white px-2 py-1 text-[11px] font-semibold text-[#6B7280] hover:border-[#841C39] hover:text-[#841C39]"
              >
                Unmap
              </button>
            ) : null}
            {stale ? (
              <button
                type="button"
                onClick={() => saveIvrMapping(params.row, "", "remove")}
                className="shrink-0 rounded-lg border border-[#F3D4DE] bg-[#FFF8FA] px-2 py-1 text-[11px] font-semibold text-[#841C39] hover:bg-[#FCEEF3]"
              >
                Remove IVR
              </button>
            ) : null}
          </div>
        );
      },
    },
    {
      headerName: "Action",
      field: "action",
      minWidth: 60,
      renderCell: (params: YhTableCellParams) => (
        params.row?.isSuperAdmin ? (
          <span className="text-[12px] font-medium text-[#841C39]">Protected</span>
        ) : (
        <button
          type="button"
          className="flex h-8 w-8 items-center justify-center rounded-full text-[#9CA3AF] transition hover:bg-[#F3F4F6] hover:text-[#4B5563]"
          onClick={(event: any) =>
            handlePopOver(event, params.row._id, params.row.status, params.row)
          }
        >
          <VerticalDotIcon />
        </button>
        )
      ),
    },
  ];

  // Account status modal

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedUser({ ...selectedUser, status: +event.target.value });
  };

  const dialogHeaderContent = () => {
    return (
      <Box marginTop={1} marginRight={3} sx={{ cursor: "pointer" }}>
        <CloseIcon onClick={() => setIsDialogOpen(false)} />
      </Box>
    );
  };
  // const handelDateRange = async (value: any) => {
  //   // console.log((value[0]),"newvalue")
  //   // console.log((value[1]),"newvalue")
  //   console.log(value[0]?.format("DD/MM/yyyy"), "newvalue");
  //   console.log(value[1]?.format("DD/MM/yyyy"), "newvalue");
  //   const from = value[0]?.format("DD/MM/yyyy");
  //   const to = value[1]?.format("DD/MM/yyyy");
  //   if (from && to) {
  //     try {
  //       const response = await getDateWiseTeam(
  //         store.getState().auth.userId,
  //         from,
  //         to
  //       );
  //       customErrorHandler(response);
  //       console.log("response", response);
  //       let totalTime: any = "0:0";

  //       const source = response.data.map((userData: any) => {
  //         return {
  //           name: (
  //             <>
  //               <Typography sx={classes.fullName}>{userData?.name}</Typography>
  //               {userData?.userOffices[0]?.emp_type ? (
  //                 <Typography sx={classes.emp_type_btn}>
  //                   {userData?.userOffices[0]?.emp_type}
  //                 </Typography>
  //               ) : (
  //                 ""
  //               )}
  //               {userData?.in_complete && (
  //                 <Typography sx={classes.Info_btn}>
  //                   Information incomplete
  //                 </Typography>
  //               )}
  //             </>
  //           ),

  //           Designation: (
  //             <>
  //               <Typography sx={classes.rowtext}>
  //                 {userData?.userOffices[0]?.designation}
  //               </Typography>
  //               <Typography sx={[classes.rowtext, classes.dipt]}>
  //                 {userData?.userOffices[0]?.department}
  //               </Typography>
  //             </>
  //           ),
  //           email: (
  //             <>
  //               <Typography sx={classes.rowtext}>
  //                 <img src={EmailListIcon} alt="" />
  //                 {userData.email}
  //               </Typography>
  //               <Typography sx={classes.rowtext}>
  //                 <img src={PhoneListIcon} alt="" />
  //                 {userData.phone}
  //               </Typography>
  //               <Typography sx={classes.rowtext}>
  //                 <img src={PhoneListIcon} alt="" />
  //                 {userData.whatsapp}
  //               </Typography>
  //             </>
  //           ),

  //           location: (
  //             <Typography sx={classes.rowtext}>
  //               {userData.city}, {userData.states[0]?.state_name} <br />{" "}
  //               {userData.countries[0]?.country_name}{" "}
  //             </Typography>
  //           ),
  //           dob: (
  //             <>
  //               {/* <Typography sx={classes.rowtext}>
  //               Joining Date: {userData?.userOffices[0]?.joining}
  //             </Typography> */}
  //               <Typography sx={classes.rowtext}>
  //                 Birthday: {userData?.dob}
  //               </Typography>
  //             </>
  //           ),

  //           LeaveBalance: (
  //             <>
  //               <Typography sx={classes.rowtext}>
  //                 Total Leave : {userData?.leaves[0]?.total_leave_available}
  //               </Typography>

  //               <Typography sx={classes.rowtext}>
  //                 Sick Leave: {userData?.leaves[0]?.sick_leave_available}
  //               </Typography>

  //               <Typography sx={classes.rowtext}>
  //                 Casual Leave: {userData?.leaves[0]?.casual_leave_available}
  //               </Typography>
  //             </>
  //           ),

  //           status: (
  //             <>
  //               {privileges &&
  //                 (privileges?.["Team List"]?.includes("delete") ||
  //                   privileges?.["Team List"]?.includes("full control")) ? (
  //                 <Box
  //                   sx={
  //                     userData.status == 0
  //                       ? classes.deActive
  //                       : classes.activeBtn
  //                   }
  //                 >
  //                   <CustomButton
  //                     label={userData.status == 0 ? "Deactive" : "Active"}
  //                     buttonType="primaryBtn"
  //                     onClick={() => {
  //                       changeStatus(userData.status, userData.user_id);
  //                     }}
  //                   />
  //                 </Box>
  //               ) : (
  //                 ""
  //               )}
  //             </>
  //           ),

  //           action: (
  //             <>
  //               <Box sx={classes.verticalDotButton}>
  //                 <Button
  //                   onClick={(event: any) =>
  //                     handlePopOver(event, userData._id, userData.status)
  //                   }
  //                 >
  //                   <VerticalDotIcon />
  //                 </Button>
  //               </Box>
  //               {/* <Box sx={classes.buttonWrapper}>
  //               <CustomButton
  //                 label="Edit"
  //                 buttonType="iconBtn"
  //                 onClick={() => {
  //                   handleEdit(userData._id);
  //                 }}
  //               />

  //               <CustomButton
  //                 label="Add Loan"
  //                 buttonType="iconBtn"
  //                 onClick={() => handleLoan(userData?._id, userData?.status)}
  //               />

  //               <CustomButton
  //                 label="View Salary"
  //                 buttonType="iconBtn"
  //                 onClick={() => handleViewSalary(userData?.user_id)}
  //               />
  //             </Box> */}
  //             </>
  //           ),
  //         };
  //       });
  //       setUserDataSource([...source]);
  //       const source1 = response.data.map((userData: any) => {
  //         return userData;
  //       });
  //       setUserDataSource1([...source1]);
  //       setFixData([...source]);
  //       setApiResponse(false);
  //     } catch (error: any) {
  //       setApiResponse(false);
  //       openErrorNotification(
  //         isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
  //       );
  //     }
  //   }
  // };
  const updateDetails = async (type: any) => {
    try {
      if (passwordConfirm.length && passwordConfirm === password) {
        const response2 = await changeUserPassword({
          id: passwordResetId,
          password: password,
        });
        openSuccessNotification(response2.message);

        handleSetPasswordClose();
      } else {
        openErrorNotification("Value Not Matched");
      }
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };
  const dialogTitleContent = () => {
    return (
      <>
        <Box sx={classes.content}>
          <Grid container>
            <Grid item xs={12}>
              <Typography sx={classes.pageHeading}>Account Status</Typography>
              <Typography sx={classes.pageSubHeading}>
                Change your account status
              </Typography>
            </Grid>
            {/* <DateRangePicker localeText={{ start: 'Check-in', end: 'Check-out' }} /> */}
            <Grid item xs={12} mt={5}>
              <Typography sx={classes.statusHeading}>Current Status</Typography>

              <Box sx={classes.checkBoxWarapper}>
                <CustomRadioButton
                  value={1}
                  checked={selectedUser.status == 1}
                  onChange={handleRadioChange}
                  label="Active"
                />

                <CustomRadioButton
                  value={0}
                  checked={selectedUser.status == 0}
                  onChange={handleRadioChange}
                  label="Deactive"
                />
              </Box>

              <Box>
                <CustomButton
                  onClick={() => {
                    // handleDeleteAccount();
                  }}
                  label="Delete Account"
                  buttonType="iconBtn"
                  customClasses={{ color: "red" }}
                />
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box sx={classes.buttonWrapperDialog}>
                <CustomButton
                  label="Save"
                  onClick={() => { }}
                  buttonType="primaryBtn"
                />
                <CustomButton
                  label="Cancel"
                  onClick={() => {
                    setIsDialogOpen(false);
                  }}
                  buttonType="secondaryBtn"
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </>
    );
  };

  const getShowAllPage = () => {
    const canCreate =
      privileges?.["Team List"]?.includes("create") ||
      privileges?.["Team List"]?.includes("full control");

    return (
      <>
        <div className="flex h-full min-h-0 w-full flex-col">
          {/* Header: title left, Add Team right */}
          <div className="mb-4 flex shrink-0 flex-wrap items-start justify-between gap-3">
            <div className="min-w-0">
              <h3 className="text-xl font-bold tracking-tight text-[#111827]">
                Team List
              </h3>
              <p className="mt-1 text-sm text-[#6B7280]">
                Manage your team here.
              </p>
            </div>
            {canCreate ? (
              <button
                type="button"
                onClick={() => onClickHandler()}
                className="inline-flex h-10 shrink-0 items-center gap-2 rounded-xl bg-[#A02448] px-4 text-sm font-semibold text-white shadow-sm transition hover:bg-[#4A4EDB]"
              >
                + Add Team
              </button>
            ) : null}
          </div>

          <LiveIvrCallsPanel />

          {/* Toolbar: search + filters on one row */}
          <div className="mb-4 flex shrink-0 flex-wrap items-center gap-3">
            <div className="w-full max-w-[420px] flex-1">
              <YhInput
                placeholder="Search"
                type="search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                autoFocus={isSearchFocused}
                startAdornment={<SearchSvg />}
                onFocus={() => setIsSearchFocused(true)}
                onBlur={() => setIsSearchFocused(false)}
              />
            </div>
            <div className="ml-auto flex flex-wrap items-center gap-2">
              <span className="text-xs font-medium text-[#6B7280]">Filters</span>
              <YhSelect
                placeholder="Select team"
                searchPlaceholder="Search team..."
                showOptionIcon={false}
                className="!w-[200px] shrink-0"
                value={
                  offialDetailState?.team_id?.id
                    ? String(offialDetailState.team_id.id)
                    : ""
                }
                options={teamOptions}
                onChange={(e) => handleTeamChange(String(e.target.value || ""))}
              />
              <YhDateRangePicker
                className="!w-[240px] shrink-0"
                placeholder="MM/DD/YYYY - MM/DD/YYYY"
                value={{
                  from: selectedDateRange?.from || null,
                  to: selectedDateRange?.to || null,
                }}
                onChange={(range) => setSelectedDateRange(range)}
              />
            </div>
          </div>

          <div className="min-h-0 flex-1">
            {privileges &&
            (privileges?.["Team List"]?.includes("view") ||
              privileges?.["Team List"]?.includes("full control")) ? (
              <YhTable
                columns={columns}
                rows={userDataSource1 || []}
                getRowId={(row) => row._id}
                rowHeight={90}
                loading={apiResponse}
                emptyMessage={
                  activeOrganizationId
                    ? "No team members for this organization"
                    : "No team members yet"
                }
                className="min-h-[320px]"
                page={paginationModel.page}
                pageSize={paginationModel.pageSize}
                totalRows={metaData?.total || 0}
                onPageChange={(p) =>
                  setPaginationModel((prev) => ({ ...prev, page: p }))
                }
                onPageSizeChange={(s) =>
                  setPaginationModel({ pageSize: s, page: 0 })
                }
              />
            ) : null}

            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
            >
              <Box sx={classes.innerPopOver}>
                {privileges &&
                (privileges?.["Team List"]?.includes("edit") ||
                  privileges?.["Team List"]?.includes("full control")) ? (
                  <CustomButton
                    label="Edit"
                    buttonType="iconBtn"
                    onClick={() => {
                      handleEdit(userRow_Id ?? "");
                    }}
                  />
                ) : (
                  ""
                )}
                <CustomButton
                  label="Reset Password"
                  buttonType="iconBtn"
                  onClick={() => handleSetPassword(userRow_Id ?? "")}
                />
                {canGrantExport && popOverRow ? (
                  <CustomButton
                    label="Extra Access"
                    buttonType="iconBtn"
                    onClick={() => openAccessDialog(popOverRow)}
                  />
                ) : null}
                {privileges &&
                (privileges?.["Team List"]?.includes("edit") ||
                  privileges?.["Team List"]?.includes("delete") ||
                  privileges?.["Team List"]?.includes("full control") ||
                  privileges?.["Archive Team List"]?.includes("create") ||
                  privileges?.["Archive Team List"]?.includes("edit") ||
                  privileges?.["Archive Team List"]?.includes("full control")) ? (
                  <CustomButton
                    label="Archive"
                    buttonType="iconBtn"
                    onClick={() => {
                      const id = String(
                        popOverRow?.user_id ||
                          popOverRow?._id ||
                          userRow_Id ||
                          ""
                      );
                      const currentStatus =
                        rowStatus ?? popOverRow?.status ?? 1;
                      handleClose();
                      if (!id) return;
                      if (popOverRow?.isSuperAdmin) {
                        openErrorNotification(
                          "Super admin cannot be archived"
                        );
                        return;
                      }
                      if (
                        window.confirm(
                          "Archive this team member? They will move to Archive Team List."
                        )
                      ) {
                        // changeStatus toggles: active (1) → archived (0)
                        changeStatus(currentStatus, id);
                      }
                    }}
                  />
                ) : null}
              </Box>
            </Popover>
          </div>

          {apiResponse && <CustomLoader apiResponse={false} />}
        </div>

        <CustomDialog
          fullScreen={true}
          isDialogOpen={isDialogOpen}
          dialogHeaderContent={dialogHeaderContent()}
          dialogTitleContent={dialogTitleContent()}
        />

        {isDialogOpenLoan && (
          <AddLoan
            isDialogOpenLoan={true}
            handleCloseLoan={handleCloseLoan}
            userId={userId}
            status={status}
          />
        )}

        {isDialogOpenLoanList && (
          <LoanList
            isDialogOpenLoan={true}
            handleCloseLoan={handleCloseLoanList}
            userId={userId}
            status={status}
          />
        )}
        <YhModal
          open={passwordReset}
          onClose={handleSetPasswordClose}
          width={420}
          title="Reset Password"
          className="!min-h-[280px]"
          footer={
            <div className="flex justify-end gap-2">
              <YhButton
                variant="secondary"
                size="sm"
                onClick={handleSetPasswordClose}
              >
                Cancel
              </YhButton>
              <YhButton
                variant="primary"
                size="sm"
                onClick={() => updateDetails("password")}
              >
                Save
              </YhButton>
            </div>
          }
        >
          <div className="flex min-h-[140px] flex-col gap-4 py-1">
            <YhInput
              autoFocus
              label="Create Password"
              placeholder="Enter password"
              type="password"
              name="createPassword"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <YhInput
              label="Confirm Password"
              placeholder="Confirm password"
              type="password"
              name="confirmPassword"
              value={passwordConfirm}
              onChange={(e) => setPasswordConfirm(e.target.value)}
            />
          </div>
        </YhModal>

        <YhModal
          open={!!accessRow}
          onClose={closeAccessDialog}
          width={480}
          title="Extra Access"
          footer={
            <div className="flex justify-end gap-2">
              <YhButton
                variant="secondary"
                size="sm"
                onClick={closeAccessDialog}
              >
                Cancel
              </YhButton>
              <YhButton
                variant="primary"
                size="sm"
                disabled={savingGrants}
                onClick={handleSaveGrants}
              >
                {savingGrants ? "Saving…" : "Save"}
              </YhButton>
            </div>
          }
        >
          <div className="flex flex-col gap-4 py-1">
            <div className="rounded-xl bg-[#F8FAFC] p-3">
              <div className="text-sm font-semibold text-[#111827]">
                {accessRow?.name || "—"}
              </div>
              <div className="mt-0.5 text-xs text-[#6B7280]">
                {accessRow?.email || ""}
              </div>
            </div>

            <p className="text-xs text-[#6B7280]">
              These permissions apply to this person only, on top of whatever
              their role already allows. To change it for everyone on the role
              instead, use Settings → Roles &amp; Privileges.
            </p>

            {[
              {
                key: "leadExport" as const,
                title: "Export leads",
                hint: "Shows the Download button on the lead lists.",
              },
              {
                key: "paymentsView" as const,
                title: "View payments & payment links",
                hint: "Opens the Payments page and shows Copy link.",
              },
              {
                key: "paymentsSend" as const,
                title: "Send / resend payment links",
                hint: "Allows emailing a payment link to a customer.",
              },
            ].map((item) => (
              <label
                key={item.key}
                className="flex cursor-pointer items-start gap-3 rounded-xl border border-[#E5E7EB] p-3 transition hover:border-[#D4B8C0]"
              >
                <input
                  type="checkbox"
                  className="mt-0.5 h-4 w-4 accent-[#A02448]"
                  checked={accessGrants[item.key]}
                  onChange={(e) =>
                    setAccessGrants((prev) => ({
                      ...prev,
                      [item.key]: e.target.checked,
                    }))
                  }
                />
                <span>
                  <span className="block text-sm font-medium text-[#111827]">
                    {item.title}
                  </span>
                  <span className="block text-xs text-[#6B7280]">
                    {item.hint}
                  </span>
                </span>
              </label>
            ))}

            <p className="text-xs text-[#92400E]">
              The user must log out and log back in for changes to take effect.
            </p>
          </div>
        </YhModal>
      </>
    );
  };

  return getShowAllPage();
};

export default ShowAll;

